import { useState } from "react";

export default function CTA() {
  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();

    if (honeypot) {
      setFormStatus("success");
      return;
    }

    const formData = new FormData(form);
    formData.delete("phone_alt");

    try {
      const response = await fetch("https://readdy.ai/api/form/d9q2lffnahb7382ov560", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === "OK") {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("error");
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormError(serverMsg || "提交失败，请稍后重试");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络错误，请检查网络后重试");
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-accent-600 rounded-lg overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
                立即获取专属安全方案
              </h2>
              <p className="text-background-50/80 text-sm leading-relaxed mb-6">
                填写简单信息，我们的安全顾问将在24小时内与您联系，为您提供免费上门评估和定制化方案建议。
              </p>
              <div className="flex items-center gap-4 text-background-50/80 text-sm">
                <div className="flex items-center gap-1.5">
                  <i className="ri-phone-line"></i>
                  <span>400-888-9999</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-mail-line"></i>
                  <span>service@anmaster.com</span>
                </div>
              </div>
            </div>

            <div className="bg-background-50 p-8 md:p-10">
              {formStatus === "success" ? (
                <div className="flex flex-col items-center justify-center h-full py-8 text-center animate-scale-in">
                  <div className="w-16 h-16 bg-accent-100 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-check-line text-2xl text-accent-600"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 font-heading mb-2">
                    提交成功！
                  </h3>
                  <p className="text-sm text-foreground-600">
                    我们的安全顾问将在24小时内与您联系
                  </p>
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  data-readdy-form
                  className="flex flex-col gap-4"
                >
                  <div>
                    <label htmlFor="cta-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名 <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="cta-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 bg-background-50 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="cta-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      电话 <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="cta-phone"
                      name="phone"
                      type="tel"
                      required
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 bg-background-50 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-300 transition-colors"
                      placeholder="请输入您的手机号"
                    />
                  </div>
                  <div>
                    <label htmlFor="cta-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      邮箱
                    </label>
                    <input
                      id="cta-email"
                      name="email"
                      type="email"
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 bg-background-50 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-300 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="cta-need" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      需求类型
                    </label>
                    <select
                      id="cta-need"
                      name="need_type"
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 bg-background-50 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-300 transition-colors"
                    >
                      <option value="">请选择</option>
                      <option value="family">家庭安全</option>
                      <option value="business">企业防护</option>
                      <option value="personal">个人保障</option>
                      <option value="other">其他需求</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="cta-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      需求描述
                    </label>
                    <textarea
                      id="cta-message"
                      name="message"
                      rows={3}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-md border border-background-200 text-sm text-foreground-800 bg-background-50 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-300 transition-colors resize-none"
                      placeholder="请简单描述您的安全需求（选填，最多500字）"
                    ></textarea>
                  </div>
                  <div className="form-website-alt-wrap">
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                  </div>
                  {formStatus === "error" && (
                    <div className="text-sm text-red-600 bg-red-50 px-4 py-2.5 rounded-md">
                      {formError}
                    </div>
                  )}
                  <button
                    type="submit"
                    className="w-full bg-accent-600 hover:bg-accent-700 text-background-50 py-3 rounded-md text-sm font-medium transition-colors duration-200 mt-1 whitespace-nowrap"
                  >
                    提交咨询
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}